import { TableRow, TableCell, Typography, Button } from '@mui/material'
import type { FC } from 'react'
import { Link } from 'react-router-dom'

import type { TransformedUnassignedApplicantData } from '@/lib/apollo/query/getUnassignedApplicants'
import { rowHeight } from '@/utils/table'

export type Props = {
  applicant: TransformedUnassignedApplicantData
}

const Row: FC<Props> = ({ applicant }) => (
  <TableRow hover key={applicant.id} sx={{ height: rowHeight }}>
    <TableCell component="th" scope="row">
      <Typography variant="body2" noWrap>
        {applicant.fullName}
      </Typography>
    </TableCell>
    <TableCell align="right" padding="none">
      <Button
        size="small"
        variant="text"
        component={Link}
        to={`/applicant/${applicant.id}`}
        sx={{ whitespace: 'noWrap' }}
      >
        View applicant
      </Button>
    </TableCell>
  </TableRow>
)

export default Row
